import { Entity } from '@backstage/catalog-model';
import { MLFLOW_MODEL_NAME_ANNOTATION } from '@internal/plugin-mlflow-common';

/**
 * Use this in EntityPage so the card only shows up on entities that actually
 * have a model behind them.
 */
export const isMlflowAvailable = (entity: Entity): boolean =>
  Boolean(entity.metadata.annotations?.[MLFLOW_MODEL_NAME_ANNOTATION]);
